import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type StepCardProps = {
  title: string;
  subTitle?: string;
  children: React.ReactNode;
};

export function StepCard({ title, subTitle, children }: StepCardProps) {
  return (
    <Box w={'100%'} flex={1}>
      <Text size="displaySm" fw={FONT_WEIGHTS.semibold} c="gray.10" ml={8}>
        {title}
      </Text>

      {subTitle && (
        <Text size="md" fw={FONT_WEIGHTS.medium} mt="xxxs" c="gray.10" ml={8}>
          {subTitle}
        </Text>
      )}

      <Box mt={24}>{children}</Box>
    </Box>
  );
}
